/**
 * 应用主入口
 * @author jasonelchen
 */
import React from 'react'
// import { render } from 'react-dom'
import { createRoot } from 'react-dom/client';

import App from './App'
import './styles/index.less'
import { initAegis } from './library/rum'
initAegis()

const root = createRoot(document.getElementById('root'));
root.render(<App />);
